(() => {
  const triggerEvent = (elem, files) => {
    window.swinger.eventHub.trigger(elem, 'swinger-file-upload:files', {
      files,
    });
  };

  window.swinger.eventHub.register('drag dragstart dragend dragover dragenter dragleave drop', '.swinger-file-upload__label', (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  window.swinger.eventHub.register('dragover dragenter', '.swinger-file-upload__label', (e) => {
    e.target.closest('.swinger-file-upload').classList.add('swinger-file-upload--is-dragover');
  });

  window.swinger.eventHub.register('dragleave dragend drop', '.swinger-file-upload__label', (e) => {
    e.target.closest('.swinger-file-upload').classList.remove('swinger-file-upload--is-dragover');
  });

  window.swinger.eventHub.register('drop', '.swinger-file-upload__label', (e) => {
    triggerEvent(e.target.closest('.swinger-file-upload'), e.dataTransfer.files);
  });

  window.swinger.eventHub.register('change', '.swinger-file-upload__input', (e) => {
    triggerEvent(e.target.closest('.swinger-file-upload'), e.target.files);
  });

  document.addEventListener('swinger-file-upload:files', (e) => {
    console.log(e);
  }, true);
})();
